import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import Icon from "../Icon";
import style from "./style.module.scss";
export default function MessageBox(props) {
    const { children, type, className } = props;
    // Add styles based on type.
    const styles = [];
    styles.push(style["message-box--" + type]);
    styles.push(className);
    return (_jsx("div", { className: classNames(style["message-box"], styles), children: _jsxs("div", { className: style["message-box__message"], children: [_jsx(Icon, { name: type }), _jsx("span", { children: children })] }) }));
}
